/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { HiChevronUpDown, HiChevronUp, HiChevronDown  } from "react-icons/hi2";
import { GiCheckMark } from "react-icons/gi";
import { HiOutlineXMark } from "react-icons/hi2";

// https://gemini.google.com/app/0e202e83b68a7718
// create react native component multi select dropdown as a component and return seleted items to parent
// try again with selected item checked on reload 
/**
 * A multi-select dropdown component for web-based React applications.
 * @param {object} props - The component's props.
 * @param {Array<object>} props.items - The list of items to display. Each item should have a 'id' and 'name' property.
 * @param {Function} props.onSelectionChange - Callback function that receives the array of selected items.
 * @param {string} props.title - The title for the dropdown.
 * @param {Array<object>} props.initialSelectedItems - The initial list of selected items.
 */
const MultiSelectDropdown = ({ items = [], onSelectionChange, title, initialSelectedItems }) => {
    // console.log('items ', items)
    // console.log('mySelectedItems ', mySelectedItems)
    const { seller } = useSelector(state => state.seller)

    const sellerId = seller._id 
    const sellerPrimaryColor1 = seller.frontEndPrimaryColor1
    //const sellerPrimaryColor2 =  state.frontEndPrimaryColor2
    const sellerSecondaryColor1 = seller.frontEndSecondaryColor1
    
    const sellerArrHexOpacityColorSuffixes = seller?.hexOpacityColorSuffixes?.split(';') || [];// 'FF;80;1A' Darkest is FF, Medium is 80, Lightest is 1A
    const sellerColorSuffixDark = sellerArrHexOpacityColorSuffixes[0] || 'FF';
    const sellerColorSuffixMedium = sellerArrHexOpacityColorSuffixes[1] || '80';
    const sellerColorSuffixLight = sellerArrHexOpacityColorSuffixes[2] || '1A';
    
    const [isOpen, setIsOpen] = useState(false);
    const [selectedItems, setSelectedItems] = useState(initialSelectedItems);

    useEffect(() => {
      setSelectedItems(initialSelectedItems);
    }, [initialSelectedItems]); //@param {Array<object>} props.initialSelectedItems - The initial list of selected items.
 

   //const [selectedItems, setSelectedItems] = useState([]);

  // Toggles the selection of an item and calls the parent's callback
  const toggleItem = (item) => {
    //console.log('item ', item)
    const isSelected = selectedItems.some((selectedItem) => selectedItem.id === item.id);
    let newSelectedItems;

    if (isSelected) {
      newSelectedItems = selectedItems.filter((selectedItem) => selectedItem.id !== item.id);
    } else {
      newSelectedItems = [...selectedItems, item];
    }
    
    setSelectedItems(newSelectedItems);
    // Call the onSelectionChange callback if it's a function
    if (typeof onSelectionChange === 'function') {
      onSelectionChange(newSelectedItems);
    }
  };

  const selectedText = () => {
    if (selectedItems.length === 0) {
      return title || 'Select Items';
    }
    return `${selectedItems.length} Selected`;
  };

  return (
    <div className="relative w-full max-w-sm mx-auto my-1 font-sans antialiased">
      {/* button Main button to toggle the dropdown */}
      <button onClick={() => setIsOpen(!isOpen)}
        className="flex items-center justify-between w-full pl-2 p-1 text-left transition-all duration-200 
        bg-white border border-gray-300 rounded-lg cursor-pointer"
        style={{
            color:sellerPrimaryColor1 + sellerColorSuffixDark, 
            borderColor:sellerPrimaryColor1 + sellerColorSuffixDark
          }}>
        <span className="truncate font-normal text-[15px]" 
          style={{
            color:sellerPrimaryColor1 + sellerColorSuffixDark, 
            borderColor:sellerPrimaryColor1 + sellerColorSuffixDark
          }}>
          {selectedText()}
        </span>
        <HiChevronUpDown className="hidden w-7 h-7 ml-2 font-bold" style={{color:sellerPrimaryColor1}} />
        <HiChevronUp className={` ${!isOpen ? 'hidden' : 'block'} w-6 h-6 ml-2 font-bold text-red-700 `} />
        <HiChevronDown className={` ${isOpen ? 'hidden' : 'block'} w-6 h-6 ml-2 font-bold text-green-700`} />
      </button>

      {/* The dropdown panel that appears when the button is clicked */}
      {isOpen && (
        <div className="absolute z-10 w-full mt-2 transition-opacity duration-200 bg-white 
            border border-gray-300 rounded-lg shadow-lg" 
            style={{
              color:sellerPrimaryColor1, 
              borderColor:sellerPrimaryColor1
            }}>
          <div className="flex items-center justify-between p-2 border-b border-gray-600"
            style={{
              color:sellerPrimaryColor1, 
              borderColor:sellerPrimaryColor1
            }}>
            <h3 className="text-[14px] font-semibold" 
                style={{
                  color:sellerPrimaryColor1, 
                  borderColor:sellerPrimaryColor1
                }}>
                {title || 'Select Items'}
            </h3>
            <button onClick={() => setIsOpen(false)}
                className="p-1 transition-colors duration-200 rounded-full hover:bg-gray-200
                focus:outline-none focus:ring-2 focus:ring-blue-500"
                style={{
                  color:sellerPrimaryColor1, 
                  borderColor:sellerPrimaryColor1
                }}>
                <HiOutlineXMark className="w-5 h-5 text-red-500" />
            </button>
        </div>
        <div className="max-h-64 border-2 border-gray-200 overflow-y-auto" 
            style={{color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
            {/* Maps through the items to create selectable list items */}
            {items.map((item) => (
                <button key={item.id} onClick={() => toggleItem(item)}
                    className="flex items-center justify-between w-full px-3 py-1 text-left transition-colors 
                      duration-200 hover:bg-gray-200 focus:outline-none focus:bg-gray-200">
                        <span className="font-normal text-[14px] truncate" style={{color:sellerPrimaryColor1}}>
                            {item.name}
                        </span>
                        {
                            selectedItems.some((selectedItem) => selectedItem.id === item.id) && (
                            <GiCheckMark className="w-5 h-5 text-green-500" />
                            )
                        }
                </button>
            ))}
          </div>
       </div>
    )}
    </div>
  );
};

export default MultiSelectDropdown;



// import React, { useState, useRef, useEffect } from 'react';
// import {  useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';

// // The main App component that contains the multi-select dropdown.
// const MultiSelectDropdown = ({ options }) => {


//     const navigate = useNavigate()
//     const dispatch = useDispatch()
    
// //   const options = [
// //     { value: 'option1', label: 'Option 1' },
// //     { value: 'option2', label: 'Option 2' },
// //     { value: 'option3', label: 'Option 3' },
// //     { value: 'option4', label: 'Option 4' },
// //     { value: 'option5', label: 'Option 5' },
// //     { value: 'option6', label: 'Option 6' },
// //     { value: 'option7', label: 'Option 7' },
// //     { value: 'option8', label: 'Option 8' },
// //   ];

//   const [selectedValues, setSelectedValues] = useState([]);
//   //console.log('selectedValues ', selectedValues)
//   const [isOpen, setIsOpen] = useState(false);
//   const dropdownRef = useRef(null);

//   const handleToggle = () => {
//     setIsOpen(!isOpen);
//   };

//   const handleSelect = (value) => {
//     let mySelectedValues = [];
//     setSelectedValues((prevSelected) => {
//       if (prevSelected.includes(value)) {
//         // console.log('value ', value, '\nselectedValues ', selectedValues)
//         // console.log(prevSelected)
//         mySelectedValues = prevSelected.filter((item) => item !== value);
//         setSelectedValues(mySelectedValues);
//         //console.log('SelectedValues1 ', mySelectedValues)
//         return prevSelected.filter((item) => item !== value);
//       } else {
//         mySelectedValues = [...prevSelected, value];
//         //prevSelected = myVar
//         //prevSelected.push(value)
//         setSelectedValues(mySelectedValues);
//         //console.log('mySelectedValues2 ', mySelectedValues) //, ' 'prevSelected ', prevSelected
//         return [...prevSelected, value];
//       }
//     });

//   };

//   const getSelectedLabels = () => {
//     if (selectedValues.length === 0) {
//       return 'Select options...';
//     }
//     return selectedValues.map(value => {
//       const option = options.find(o => o.value === value);
//       return option ? option.label : '';
//     }).join(', ');
//   };

//   // Close the dropdown when clicking outside of it.
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsOpen(false);
//       }
//     };
//     document.addEventListener('mousedown', handleClickOutside);
//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, [dropdownRef]);

//   return (
//     <div className="flex items-center justify-center bg-gray-100 p-0">
//     { /*min-h-screen*/ }
//       <div className="relative w-full max-w-sm" ref={dropdownRef}>
//         <div onClick={handleToggle}
//           className="bg-white border border-gray-300 rounded-md shadow-sm cursor-pointer p-1 flex 
//           items-center justify-between">
//           <span className="text-gray-700 font-normal text-sm truncate" 
//             style={{color:sellerPrimaryColor1}}>
//             {getSelectedLabels()}
//           </span>
//           <svg
//             className={`w-5 h-5 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
//             fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
//             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
//           </svg>
//         </div>
        
//         {isOpen && (
//           <div className="absolute top-full left-0 mt-2 w-full bg-white border 
//           border-gray-300 rounded-md shadow-lg z-10 max-h-60 overflow-y-auto" >
//             {options.map((option) => (
//               <div key={option.value} onClick={() => handleSelect(option.value)}
//                 className="pl-2 p-1 cursor-pointer hover:bg-gray-100 flex items-center">
//                 <input type="checkbox" checked={selectedValues.includes(option.value)} 
//                     onChange={() => handleSelect(option.value)}
//                     className="mr-2 h-4 w-4 text-blue-600 rounded focus:ring-blue-500 border-gray-300" />
//                 <span className="font-normal text-sm" style={{color:sellerPrimaryColor1}}>{option.label}</span>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default MultiSelectDropdown;
